import _ from 'lodash';

import { POPUPS } from '@common/constants/popups';
import { getAuthData } from '@common/helpers/auth';
import { store } from '@app/dev/index/terminalApp';
import { getPopupDispatchers } from '@app/dev/contexts/popup';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { ConfirmRegistrationNewCard } from '@app/dev/actions/terminal';

export const confirmation = async (form, cardData) => {
  const { token } = getAuthData();
  const { openPopup } = getPopupDispatchers();

  const inputData = {
    ...form,
    CardId: cardData.id,
    Name: _.capitalize(form.Name),
    Surname: _.capitalize(form.Surname),
  };

  const { data } = await swarmRequest(
    { token, filter: { document_number: form.CNP } },
    'terminal_find_player',
  );

  const playerNotFound = data.length && data[0].DocNumber !== form.CNP;

  if (playerNotFound) return;

  if (data.length === 0) {
    store.dispatch(ConfirmRegistrationNewCard(JSON.stringify(inputData)));
    return;
  }

  const updateData = { ...inputData, Id: data[0].Id };
  openPopup(POPUPS.REGISTER_SUCCESS, updateData);
};
